export const AI_PROFILE_EXAMPLE_QUESTIONS: { label: string; question: string }[] = [
  { label: 'Brief', question: 'Give me a quick brief on this patient?' },
  {
    label: 'Follow up',
    question: 'What should I follow up on when checking in on this patient next?'
  },
  {
    label: 'Discharge',
    question:
      'Prepare a discharge summary and transition plan with high-risk factors and coping skills for this member as well as resources in their area using: https://help.affecttherapeutics.com/'
  }
];
